import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../state'
import * as content from '../../../content'

/**
 * Displays the Admin Center tenant list and platform tenant actions.
 */
@ngCore.Component({
  imports: [
    ds.table.Component,
    ds.layout.page.Component,
    ds.overlay.confirmation.Component,
    content.admin.modals.tenant.Component,
  ],
  selector: 'atn-admin-tenants-page',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.admin.tenants.Collection} */
  public readonly tenantsEc = ngCore.inject(state.admin.tenants.Collection)

  /** @see {@link state.me.Feature} */
  private readonly _meFeature = ngCore.inject(state.me.Feature)

  /** Whether the current admin user can create tenants */
  public readonly canCreateTenantSg = ngCore.computed(() =>
    state.admin.portalAccess.ContentActionAccess.canCreateTenant(
      this._meFeature.selectors.currentUser.asSignal(),
    ),
  )

  /** Canonical table input for the tenant collection. */
  public readonly tenantsTableConfigSg = ngCore.computed(
    () =>
      ({
        collection: this.tenantsEc,
        view: {
          creation: this.canCreateTenantSg(),
          search: true,
          showColumnSettings: false,
          title: 'Tenants',
        },
      }) satisfies ds.table.ec.Config.Input<state.admin.tenants.TypeParams>,
  )

  /** Name of the tenant marked for deletion */
  public tenantNameForDeleteSg = ngCore.computed(
    (
      [deletedTenant] = this.tenantsEc.plugins.editingPlugin.feature.selectors
        .deletedEntities()
        .asSignal(),
    ) => deletedTenant?.name,
  )
  /**
   * Handles the confirmation action for tenant deletion.
   */
  public confirmDeletionClickHandler(): void {
    this.tenantsEc.plugins.editingPlugin.feature.actions.submit
      .from('Confirmation.Footer.Buttons.Confirm.Clicked')
      .dispatch({ delete: true })
  }

  /**
   * Handles the cancellation action for tenant deletion.
   */
  public cancelDeletionClickHandler(): void {
    this.tenantsEc.plugins.editingPlugin.feature.actions.discard
      .from('Confirmation.Footer.Buttons.Cancel.Clicked')
      .dispatch({ delete: true })
  }
}
